// Module
var code = "<div class=\"widget-content relative\"> <table class=\"wide-table-combined\"> <tr ng-repeat=\"category in vm.categories\" ng-click=\"vm.select(category)\" ng-class=\"{'row-highlight':vm.selectedItem.guid === category.guid}\"> <td> {{category.name}} </td> </tr> </table> </div>";
// Exports
module.exports = code;